import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const AppRoot = styled(Box)({});

export const LoaderContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary[900],
}));
